import { render, staticRenderFns } from "./BetslipWinnings.vue?vue&type=template&id=69707903&"
import script from "./BetslipWinnings.vue?vue&type=script&lang=js&"
export * from "./BetslipWinnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports